import React from 'react'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { useGetResearchKeywordsChartQuery } from '../../../../app/api'
import { IResearchFilter } from '../../model/types/ResearchFilter.interface'
import { selectResearchFilters } from '../../model/researchSlice'
import { useDispatch } from 'react-redux'
import { changeKeywordsDateRange, selectKeywordsFilter } from '../../model/keywordsSlice'
import { IKeywordsFilter } from '../../model/types/KeywordsFilter.interface'
import { GraphReport } from '../../../../shared/components/cards/graph-report/GraphReport'
import { useTranslation } from 'react-i18next'

export const KeywordsByAdvertisers = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country, project, domain } = useAppSelector<IResearchFilter>(selectResearchFilters)
  const { keywords, dateRange: filter } = useAppSelector<IKeywordsFilter>(selectKeywordsFilter)
  const { date, group: date_group } = filter

  const { data } = useGetResearchKeywordsChartQuery(
    {
      body: {
        date_group,
        date,
        chart_keywords: keywords,
        project_ids: (project ? [project] : []) as unknown as number[],
        country_ids: (country ? country : []) as unknown as number[],
        domain: domain ? domain.split(',') : undefined,
      },
    },
    { skip: keywords === undefined || !keywords.length },
  )

  return (
    <GraphReport
      filter={filter}
      name={t('pages.advertisingResearch.keywordsByAdvertisers')}
      series={data}
      title={t('pages.advertisingResearch.keywordsByAdvertisers')}
      onChange={(e) => dispatch(changeKeywordsDateRange(e))}
    />
  )
}
